<section class="about section" id="about">
  <h2 class="section__title">About me</h2>
  <span class="section__subtitle">My Introduction</span>

  <div class="about__container container grid">
    <img src="./../../../assets/img/avataaars.svg" alt="" class="about__img">

    <div class="about__data">
      <p class="about__description">
        <!-- Web developer, with extensive [...] -->
      </p>
      <div class="about__info">
        <span class="about__info-title">03+</span>
        <span class="about__info-name">Years <br> experience</span>
      </div>

      <div class="about__info">
        <span class="about__info-title">20+</span>
        <span class="about__info-name">Completed <br> project</span>
      </div>

      <div class="about__info">
        <span class="about__info-title">02+</span>
        <span class="about__info-name">Companies <br> worked</span>
      </div>
    </div>

    <div class="about__buttons">
      <a download="" href="" class="button button--flex">
        <!-- ./../../../assets/CV - Izzi Giovanni Ferdinando.pdf -->
        Download CV<i class="uil uil-download-alt button__icon"></i>
      </a>
    </div>
  </div>
</section>
